import { render, staticRenderFns } from "./document-action-menu.vue?vue&type=template&id=72ab6d2a&"
import script from "./document-action-menu.vue?vue&type=script&lang=js&"
export * from "./document-action-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports